import React from "react";
import {compose} from "recompose";
import {withStyles} from "material-ui/styles/index";
import styles from "./styles";
import {connect} from "react-redux";
import {Heading} from 'react-aria-components';
import {Button} from "../ui/react-aria/Button";
import {Modal} from "../ui/react-aria/Modal";
import {Dialog} from "../ui/react-aria/Dialog";
import {Form} from "../ui/react-aria/Form";
import {archiveJobs, archiveReports, checkArchive} from "../../redux/actions";

class NotificationsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      showConfirmArchiveJobsModal: false,
      showConfirmArchiveReportsModal: false
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.isOpen !== this.props.isOpen || this.props.isOpen !== this.state.isOpen) {
      this.setState({isOpen: this.props.isOpen});
    }
  }

  onOpenChange = (isOpen) => {
    this.setState({isOpen});

    if (!isOpen) {
      this.setState({
        showConfirmArchiveJobsModal: false,
        showConfirmArchiveReportsModal: false
      });

      const {onClose} = this.props;
      if (onClose) {
        onClose();
      }
    }
  };

  archiveJobs() {
    const {profile, archiveJobs, checkArchive} = this.props;
    archiveJobs(profile.customerid).then(() => {
      checkArchive(profile.customerid);
    });
    this.close();
  }

  getJobCount() {
    const {archiveCounts} = this.props;
    return archiveCounts ? archiveCounts.jobcount : 0;
  }

  renderArchiveJobs() {
    const {archiveCounts} = this.props;
    const jobCount = this.getJobCount();

    if (jobCount === 0) return null;

    const noticeKey = jobCount === 1
      ? 'archive_notification_job_singular'
      : 'archive_notification_jobs_plural';

    return <>
      <p>{this.props.translate(noticeKey, {
        count: jobCount,
        period: archiveCounts.jobarchiveperiod
      })}</p>
      <Button variant="primary"
              onClick={() => this.showConfirmArchiveJobsModal()}>
        {this.props.translate("archive_jobs_action")}
      </Button>
    </>;
  }

  close() {
    this.onOpenChange(false);
  }

  archiveReports() {
    const {profile, archiveReports, checkArchive} = this.props;
    archiveReports(profile.customerid).then(() => {
      checkArchive(profile.customerid);
    });
    this.close();
  }

  getReportCount() {
    const {archiveCounts} = this.props;
    return archiveCounts ? archiveCounts.reportcount : 0;
  }

  renderArchiveReports() {
    const {archiveCounts} = this.props;
    const reportCount = this.getReportCount();

    if (reportCount === 0) return null;

    const noticeKey = reportCount === 1
      ? 'archive_notification_report_singular'
      : 'archive_notification_reports_plural';

    return <>
      <p>{this.props.translate(noticeKey, {
        count: reportCount,
        period: archiveCounts.reportarchiveperiod
      })}</p>
      <Button variant="primary"
              onClick={() => this.showConfirmArchiveReportsModal()}>
        {this.props.translate("delete_reports_action")}
      </Button>
    </>;
  }

  showConfirmArchiveJobsModal() {
    this.setState({
      showConfirmArchiveJobsModal: true
    });
  }

  hideConfirmArchiveJobsModal() {
    this.setState({
      showConfirmArchiveJobsModal: false
    });
  }

  renderConfirmArchiveJobsModal() {
    const {classes} = this.props;
    return (
      <Dialog>
        <div className={classes.root}>
          <Heading slot="title">{this.props.translate("confirm_archiving_jobs")}</Heading>
          <p>{this.props.translate("archive_jobs_confirmation")}</p>
          <Form>
            <div className={classes.buttons}>
              <Button
                onClick={() => this.close()}>{this.props.translate("general_cancel")}</Button>
              <Button onClick={() => this.archiveJobs()} variant="primary">
                {this.props.translate("archive_jobs_action")}
              </Button>
            </div>
          </Form>
        </div>
      </Dialog>
    )
  }

  showConfirmArchiveReportsModal() {
    this.setState({
      showConfirmArchiveReportsModal: true
    });
  }

  hideConfirmArchiveReportsModal() {
    this.setState({
      showConfirmArchiveReportsModal: false
    });
  }

  renderConfirmArchiveReportsModal() {
    const {classes} = this.props;
    return (
      <Dialog>
        <div className={classes.root}>
          <Heading slot="title">{this.props.translate("confirm_deleting_reports")}</Heading>
          <p>{this.props.translate("delete_reports_confirmation")}</p>
          <Form>
            <div className={classes.buttons}>
              <Button
                onClick={() => this.close()}>{this.props.translate("general_cancel")}</Button>
              <Button onClick={() => this.archiveReports()} variant="primary">
                {this.props.translate("delete_reports_action")}
              </Button>
            </div>
          </Form>
        </div>
      </Dialog>
    )
  }

  render() {
    const {classes, translate} = this.props;
    const {
      isOpen,
      showConfirmArchiveJobsModal,
      showConfirmArchiveReportsModal
    } = this.state;
    const isConfirm = showConfirmArchiveJobsModal || showConfirmArchiveReportsModal;
    const isActiveFeature = this.props.activeFeatures?.some(f => f.featureName === 'automated_archiving');

    return (
      <React.Fragment>
        <Modal isOpen={isOpen} isDismissable={false}
               onOpenChange={(isOpen) => this.onOpenChange(isOpen)}>
          {!isConfirm &&
            <Dialog>
              <div className={classes.root}>
                <Heading slot="title">{translate("notifications")}</Heading>
                {isActiveFeature && this.renderArchiveJobs()}
                {isActiveFeature && this.renderArchiveReports()}
                <Form>
                  <div className={classes.buttons}>
                    <Button slot="close" variant="secondary">{translate("general_cancel")}</Button>
                  </div>
                </Form>
              </div>
            </Dialog>
          }
          {showConfirmArchiveJobsModal && this.renderConfirmArchiveJobsModal()}
          {showConfirmArchiveReportsModal && this.renderConfirmArchiveReportsModal()}
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  archiveCounts: state.archiveReducer.archiveCounts,
  profile: state.profileReducer.profile,
  activeFeatures: state.appSettingReducer?.activeFeatures ?? [],
  ...state
})

const mapDispatchToProps = (dispatch, props) => ({
  archiveJobs: (customerId) => {
    return dispatch(archiveJobs(customerId));
  },
  archiveReports: (customerId) => {
    return dispatch(archiveReports(customerId));
  },
  checkArchive: (customerId) => {
    dispatch(checkArchive(customerId));
  },
})

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(NotificationsModal);
